export const SUGGEST_AFTER_LEAD_ENABLED = true
export const SUGGEST_DEFAULT_LOGIN_ENABLED = true
export const MOBILE_ASSET_PATH = 'illustrations/coches-app-download-user.svg'
export const MOBILE_INSTALL_URL = 'https://coches.onelink.me/1823422424/s476jee1'
export const DESKTOP_QR_CODE_PATH = 'coches/qr-apps-stores/qr-after-lead-cnet-240px.png'
export const DESKTOP_QR_CODE_LOGIN_PATH = 'coches/qr-apps-stores/qr-login-modal-default-240px.png'
